<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-08-18 09:57:49
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <ul>
        <li>
          <div class="left">
            <label for>用户名：</label>
            <el-input :disabled="inputshow" v-model="username"></el-input>
          </div>
          <div class="right">
            <label for>联系人：</label>
            <el-input :disabled="inputshow" v-model="contacts"></el-input>
          </div>
        </li>
        <li>
          <div class="left">
            <label for>邮箱：</label>
            <el-input :disabled="inputshow" v-model="email"></el-input>
          </div>
          <div class="right">
            <label for>联系人手机号：</label>
            <el-input :disabled="inputshow" v-model="tel"></el-input>
          </div>
        </li>
        <li>
          <div class="left">
            <label for>所在行业：</label>
            <el-select
              v-model="business"
              :disabled="inputshow"
              placeholder="请选择"
              @change="getindustry"
            >
              <el-option
                v-for="item in industrys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="right">
            <!-- <label for>地区：</label> -->
            <span
              style="
                display: inline-block;
                width: 26%;
                text-align: right;
                margin-right: 10px;
                line-height: 40px;
              "
              >地区：</span
            >
            <!-- <el-input v-if="showinput" v-model="region"></el-input> -->
            <el-select
              v-model="regionId"
              placeholder
              :disabled="inputshow"
              style="flex: 1"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.regionName"
                :value="item.regionId"
              ></el-option>
            </el-select>
          </div>
        </li>
        <li class="updata" v-if="show">
          <!-- <el-button @click="shows">修改</el-button> -->
        </li>
        <li v-if="flag" class="buttonbox">
          <div class="btn">
            <el-button type="primary" @click="dialogTableVisible = true"
              >确定</el-button
            >
            <el-button
              @click="
                (flag = false),
                  (show = true),
                  (inputshow = true),
                  (showinput = true)
              "
              >取消</el-button
            >
          </div>
        </li>
      </ul>
      <el-dialog title="特别提示" :visible.sync="dialogTableVisible">
        <p class="tip">是否确认修改资料信息</p>
        <div class="btnbox">
          <button @click="updateuser">确定</button>
          <button class="info" @click="dialogTableVisible = false">取消</button>
        </div>
      </el-dialog>
      <el-dialog title="特别提示" :visible.sync="dialogVisible">
        <span>
          已修改成功
          <br />3秒之后自动跳转到我的信息页面
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from "@/plugins/upload/bus";
import utils from "@/plugins/utils";
import { user_info, getregion, updateuserinfo } from "@/api/file"; // 接口导入

export default {
  components: {
    circleRadio: () => import("@/components/circle-radio"),
  },
  computed: {},
  data() {
    return {
      fieldName: {
        value: "regionCode",
        label: "regionName",
        children: "children",
      },
      inputshow: true,
      username: "",
      showinput: true,
      contacts: "",
      email: "",
      tel: "",
      business: "",
      flag: false,
      show: true,
      dialogTableVisible: false,
      dialogVisible: false,
      industrys: [
        {
          value: "1",
          label: "旅游机构",
        },
        {
          value: "2",
          label: "文化公司",
        },
        {
          value: "3",
          label: "文化艺术类协会",
        },
        {
          value: "4",
          label: "合唱团",
        },
        {
          value: "5",
          label: "学校/少年宫",
        },
        {
          value: "6",
          label: "指挥/教师/个人合唱爱好者",
        },
        {
          value: "7",
          label: "其他行业",
        },
      ],
      industry: "",
      region: "",
      options: [],
      regionId: "",
      userId: "",
    };
  },

  created() {},
  mounted() {
    this.getuserinfo();
    this.getregiontree();
    localStorage.setItem("states", 2);
    if (
      utils.cookies.get("token") == null ||
      utils.cookies.get("token") == undefined
    ) {
      this.$router.push({
        name: "login",
        query: this.$route.query,
      });
    }
  },
  methods: {
    handleChange(value) {},
    //获取地区
    getregiontree() {
      let data = {};
      getregion(data).then((res) => {
        if (res.code == 200) {
          this.options = res.data;
        } else {
          this.$message.info("获取地区失败");
        }
      });
    },
    //修改按钮
    shows() {
      this.inputshow = false;
      this.show = false;
      this.flag = true;
      this.showinput = false;
    },
    //获取行业值
    getindustry(val) {
      let objs = {};
      objs = this.industrys.find((item) => {
        //遍历list的数据
        return item.value === val; //筛选出匹配数据
      });
      this.industry = objs.value;
    },
    //获取用户信息
    getuserinfo() {
      user_info().then((res) => {
        this.userId = res.data.userId;
        utils.cookies.set("username", res.data.username);
        this.username = res.data.username;
        this.contacts = res.data.contacts;
        this.email = res.data.email;
        this.tel = res.data.contactsTel;
        if (res.data.business == 1) {
          this.business = "旅游机构";
        } else if (res.data.business == 2) {
          this.business = "文化公司";
        } else if (res.data.business == 3) {
          this.business = "协会";
        } else if (res.data.business == 4) {
          this.business = "合唱团";
        } else if (res.data.business == 5) {
          this.business = "学校/少年宫";
        } else if (res.data.business == 6) {
          this.business = "指挥/教师/个人合唱爱好者";
        } else if (res.data.business == 7) {
          this.business = "其他行业";
        }
        this.industry = res.data.business;
        this.regionId = res.data.regionId;
        // this.regionId.push(res.data.regionName);
      });
    },
    //修改用户信息
    updateuser() {
      let data = {
        username: this.username,
        contacts: this.contacts,
        email: this.email,
        contactsTel: this.tel,
        business: this.industry,
        regionId: this.regionId,
        userId: this.userId,
      };
      updateuserinfo(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.dialogTableVisible = false;
          this.getuserinfo();
          // this.$router.push("/web/myinfo");
        } else {
          this.$message.info(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .box {
    ul {
      li {
        display: flex;
        justify-content: center;
        margin-bottom: 60px;
        padding: 0 10%;
        transform: translateX(-5%);
        .left {
          display: flex;
          width: 50%;
          width: 400px\9;
          label {
            display: inline-block;
            width: 35%;
            text-align: right;
            line-height: 40px;
            margin-right: 10px;
          }
          .el-select {
            width: 100%;
          }
        }

        .right {
          margin-left: 30px;
          margin-left: 150px\9;
          width: 50%;
          width: 400px\9;
          display: flex;
          label {
            display: inline-block;
            width: 35%;
            text-align: right;
            line-height: 40px;
            margin-right: 10px;
          }
          .el-cascader {
            width: 100%;
          }
        }
      }
      .buttonbox {
        justify-content: center;
        transform: translateX(0);
        .btn {
          width: 100%;
          text-align: center;
        }
        .el-button {
          &:first-of-type {
          }
          &:last-of-type {
            margin-left: 15%;
          }
        }
      }
      .updata {
        justify-content: flex-end;
      }
    }
    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .el-dialog {
        width: 560px;
        height: 330px;
        border-radius: 12px;
        margin: 0 !important;
        .el-dialog__header {
          background: #24558b;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;
          .el-dialog__title {
            color: white;
          }
          .el-dialog__headerbtn {
            i {
              color: white;
            }
          }
        }
        .el-dialog__body {
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fc524c;
            line-height: 118px;
            text-align: center;
          }
          span {
            display: inline-block;
            width: 100%;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 48px;
            text-align: center;
            margin-top: 54px;
          }
          .btnbox {
            display: flex;
            justify-content: space-evenly;
            width: 59%;
            margin: auto;
            margin-top: 20px;
            button {
              width: 100px;
              height: 42px;
              background: #24558b;
              border-radius: 8px;
              color: #ffffff;
              margin: 0;
              padding: 0;
              border: 1px solid transparent; //自定义边框
              outline: none; //消除默认点击蓝色边框效果
              cursor: pointer;
            }
            .info {
              background: #ffffff;
              border: 1px solid #a6aab8;
              color: #838a9d;
            }
          }
        }
      }
    }
  }
}
</style>


